import { Flex, Grid } from '@chakra-ui/react';

import { Avatar } from 'uiToolkitV1/Avatar';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

type CompensationEmployeeDetailsProps = {
  isBottomSheet?: boolean;
};

export const CompensationEmployeeDetails = ({ isBottomSheet = false }: CompensationEmployeeDetailsProps) => (
  <Flex flexDir="column" bg="white" p="12px" borderRadius="8px" gap="12px">
    <Flex pb="8px" borderBottom="1px solid" borderColor="#E7E7E7">
      <TextBodyMedium bold>Employee details</TextBodyMedium>
    </Flex>
    <Flex flexDir="column" gap="24px">
      <Grid
        templateColumns={{ base: 'repeat(2, 1fr)', desktop: isBottomSheet ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)' }}
        gap="16px"
      >
        {/* Employee Name */}
        {!isBottomSheet && (
          <Flex flexDir="column" gap="14px">
            <TextLabel color="text.g2" mb="4px">
              Employee name
            </TextLabel>
            <Flex alignItems="center" gap="8px">
              <Avatar name="Sibley Bourn" src="" />
              <TextBodyMedium>Sibley Bourn</TextBodyMedium>
            </Flex>
          </Flex>
        )}

        {/* Manager */}
        {isBottomSheet ? (
          <Flex flexDir="column" gap="14px">
            <TextLabel color="text.g2" mb="4px">
              Manager name
            </TextLabel>
            <Flex alignItems="center" gap="8px">
              <Avatar name="Sibley Bourn" src="" />
              <TextBodyMedium>Sibley Bourn</TextBodyMedium>
            </Flex>
          </Flex>
        ) : (
          <Flex flexDir="column" gap="4px">
            <TextLabel color="text.g2" mb="4px">
              Manager
            </TextLabel>
            <Flex alignItems="center" gap="8px">
              <Avatar name="Tom Wilson" src="" />
              <Flex flexDir="column">
                <TextBodyMedium>Tom Wilson</TextBodyMedium>
                <TextLabel color="text.g2">tom.wilson@abc.co</TextLabel>
              </Flex>
            </Flex>
          </Flex>
        )}

        {/* Job title */}
        {isBottomSheet && (
          <Flex flexDir="column" gap="14px">
            <TextLabel color="text.g2">Job name</TextLabel>
            <TextBodyMedium>Manager sales</TextBodyMedium>
          </Flex>
        )}
      </Grid>

      <Grid
        templateColumns={{ base: 'repeat(2, 1fr)', desktop: isBottomSheet ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)' }}
        gap="16px"
        gridRowGap={{ base: '12px', desktop: isBottomSheet ? '12px' : '16px' }}
      >
        {/* Company name */}
        <Flex flexDir="column" gap="14px">
          <TextLabel color="text.g2">Company name</TextLabel>
          <TextBodyMedium>Company 1</TextBodyMedium>
        </Flex>

        {/* Division */}
        <Flex flexDir="column" gap="14px">
          <TextLabel color="text.g2">Division</TextLabel>
          <TextBodyMedium>Marketing</TextBodyMedium>
        </Flex>

        {/* BU */}
        <Flex flexDir="column" gap="14px">
          <TextLabel color="text.g2">BU</TextLabel>
          <TextBodyMedium>BU 1</TextBodyMedium>
        </Flex>

        {/* Department */}
        <Flex flexDir="column" gap="14px">
          <TextLabel color="text.g2">Department</TextLabel>
          <TextBodyMedium>Operations</TextBodyMedium>
        </Flex>
      </Grid>
    </Flex>
  </Flex>
);
